export default "__VITE_ASSET__DjUFMcOs__"